export const PAYMENT_METHOD_ID_CASH = '00000000-0000-4000-a000-000000000001';
export const PAYMENT_METHOD_ID_USER_ACCOUNT =
  '00000000-0000-4000-b000-000000000001';
